import React from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import TotalCost from "../totalcost/totalCost";
import Refund from "../Refund/refundcontent";
import PaymentRecieved from "../paymentrecieved/paymentrecieved";

const summaryContent = () => {
  return (
    <section className="summary-content pt-4 pb-10">
      <div>
        <Container>
          <Row>
            <Col lg={9}>
              <div className="verification-wrap">
                <TotalCost />
                <PaymentRecieved />
              </div>
            </Col>
            <Col lg={3}>
              <Refund />
            </Col>
          </Row>
        </Container>
      </div>
    </section>
  );
};

export default summaryContent;
